import { TAnswersLabels } from 'affiny-core/modules/memberchoices/types';
import { IInformation } from 'affiny-core/redux/selectors/choicesItemsSelectors/informationSelectors';
import { EMemberChoicesLabels } from '../api/models/memberchoice/memberchoice.types';
import { joinWithComma } from './strings';

export type TInformationListType = Array<{
  category: string;
  content?: string;
  isVisibleByDefault?: boolean;
}>;

type TInformationConfigurationType = Array<{
  type: keyof IInformation;
  isVisibleByDefault?: boolean;
}>;

const INFORMATION_TYPES_LIST: TInformationConfigurationType = [
  { type: 'familyStatus', isVisibleByDefault: true },
  { type: 'hair', isVisibleByDefault: true },
  { type: 'eyes', isVisibleByDefault: true },
  { type: 'bodyShapeHeightWeight', isVisibleByDefault: true },
  { type: 'smoker', isVisibleByDefault: true },
  { type: 'alcohol', isVisibleByDefault: true },
  { type: 'studies' },
  { type: 'income' },
  { type: 'childrenWish' },
  { type: 'pet' },
  { type: 'cooking' },
  { type: 'origin' },
  { type: 'nationality' },
  { type: 'religion' },
  { type: 'religionBehaviour' },
];

export const getAnswerFromLabel = (
  answerLabels: TAnswersLabels | Partial<TAnswersLabels> | undefined,
  label: EMemberChoicesLabels
): string[] | undefined => answerLabels?.[label];

export const getSimpleAnswerFromLabel = (
  answerLabels: TAnswersLabels | Partial<TAnswersLabels> | undefined,
  label: EMemberChoicesLabels
): string | undefined => answerLabels?.[label]?.[0];

const getFormattedInformationList = (
  information: IInformation,
  andTranslated?: string
): TInformationListType =>
  INFORMATION_TYPES_LIST.map(({ type, isVisibleByDefault }) => ({
    category: `profile.informations.label.${type}`,
    content: joinWithComma(information[type], andTranslated),
    isVisibleByDefault,
  }));

export const getInformationList = (
  information: IInformation,
  extendedInformation?: boolean,
  andTranslated?: string
): TInformationListType => {
  const informationList = getFormattedInformationList(
    information,
    andTranslated
  );

  return extendedInformation
    ? informationList
    : informationList.filter(item => item.isVisibleByDefault);
};
